'use client'
import React from 'react'
import { withTheme } from 'styled-components'
import { Loader } from './style'

function StyledLoader({ theme, size }) {
  const LOADER = 'loader'
  return (
    <Loader size={size} fillColor={theme?.primaryColor} data-testid={LOADER} />
  )
}

export default withTheme(StyledLoader)
